export default __webpack_public_path__ + "static/media/iconofood.49639b9c.png";